<template>
  <div class="password-hints">
    <div
      class="password-hints__hint"
      :class="getHintItemClass('pw_length')"
    >
      {{ $t('password-hints.characters-count') }}
    </div>
    <div
      class="password-hints__hint"
      :class="getHintItemClass('pw_numeric')"
    >
      {{ $t('password-hints.arabic-numbers') }}
    </div>
    <div
      class="password-hints__hint"
      :class="getHintItemClass('pw_alpha')"
    >
      {{ $t('password-hints.latin-alphabet') }}
    </div>
    <div
      class="password-hints__hint"
      :class="getHintItemClass('pw_symbols')"
    >
      {{ $t('password-hints.special-characters') }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'PasswordHint',
  props: {
    failedRules: {
      type: Object,
      default: () => {}
    },
    dirty: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getHintItemClass(ruleName) {
      if (ruleName in this.failedRules) {
        return 'invalid'
      }
      
      if (!this.dirty) {
        return ''
      }
      
      return 'valid'
    }
  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/scss/theme.scss";
.password-hints {
  margin-top: 5px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-row-gap: 2px;
  grid-column-gap: 12px;
  
  &__hint {
    font-weight: 500;
    font-size: 10px;
    line-height: 12px;
    color: $gray-2;
    
    &.valid {
      color: $active-green;
    }
    
    &.invalid {
      color: $red;
    }
  }
}
</style>
